module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-9.b93e3e32.png";